import NationalTerm from 'components/system/rootTerm/nationalTerm';
import ViewTable from 'components/ViewTable';
import { rootTermDescriptor } from 'models';
import { TYPE_GET_RAW, useFetcherSelector } from 'mrf/redux/ReduxHelper';
import useMRFTranslation from 'mrf/utils/useMRFTranslation';
import { Col, Grid } from 'mrf/view/Grid';
import Paper from 'mrf/view/Paper';
import PageTitle from 'mrf/view/Title';
import React from 'react';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';

export default function RootTermView({ match }) {
    const t = useMRFTranslation();

    const history = useHistory();

    const { id } = match.params;

    const rootTerm = useFetcherSelector({
        selector: state => state?.resources?.rootTerms,
        type: TYPE_GET_RAW,
        resource: 'rootTerms',
        endpoint: `/api/rootTerms/${id}`,
        descriptor: rootTermDescriptor,
        condition: () => true,
    });

    const rootTermFields = [
        { name: 'Root Term Type Name', keys: ['rootTermType', 'termTypeName'] },
        { name: 'Root Term Name', key: 'rootTermName' }
    ];

    return <Paper>
            <PageTitle>{t('Root Term')}</PageTitle>
        <Grid>
            <Col>
                <ViewTable
                    data={rootTerm}
                    fields={rootTermFields}
                />
            </Col>
            <Col>
                <NationalTerm history={history} match={match} t={t} rootTermId={id} />
            </Col>
        </Grid>
    </Paper>
}